import { INDUSTRIES } from "@/data/site";
import { FadeUp } from "@/components/FadeUp";

const DESCS = {
  waste: "Crushers, conveyors, balers and material handling equipment — kept turning through fast repairs.",
  transport: "Driveline and chassis components, custom brackets, and structural repairs for fleet operators.",
  manufacturing: "Production line tooling, jig & fixture work, and replacement components for processing plants.",
  mining: "Heavy-duty fabrication, machined replacement parts and breakdown response for mine site equipment.",
  construction: "Structural fabrication, modifications and machined components for engineering contractors.",
  energy: "Precision components and assemblies serving energy and resources operators across WA.",
};

export default function Industries() {
  return (
    <div data-testid="industries-page" className="section-y">
      <div className="container-x">
        <FadeUp>
          <p className="eyebrow">Industries</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary mt-4 leading-[0.95] max-w-4xl">
            Built for <span className="italic text-secondary">heavy industry</span>.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-muted-foreground">
            Six sectors where our machining and fabrication capability protects uptime and unlocks productivity.
          </p>
        </FadeUp>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <FadeUp key={ind.id} delay={i * 0.05}>
              <div data-testid="industry-card" className="group relative aspect-[5/6] overflow-hidden image-hover">
                <img src={ind.image} alt={ind.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/55 to-primary/10" />
                <div className="absolute inset-0 p-7 flex flex-col justify-end text-white">
                  <span className="eyebrow text-white/65">0{i + 1}</span>
                  <h3 className="font-serif text-3xl mt-2">{ind.title}</h3>
                  <p className="mt-3 text-white/80 text-sm leading-relaxed max-w-xs">{DESCS[ind.id]}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}
